import React from 'react';
import { Box } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import { SecondaryActionSwitch } from '@facet-wealth/design';

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'center',
  },
});

const InflationToggle = ({ classes, onChange, usePresentData }) => {
  const isChecked = usePresentData === false;

  return (
    <Tooltip
      placement="bottom"
      title={isChecked ? 'Inflated Values' : 'Present Values'}
    >
      <Box className={classes.root}>
        <SecondaryActionSwitch
          label={'Inflation'}
          value={isChecked}
          onChange={() => {
            onChange(!usePresentData);
          }}
        />
      </Box>
    </Tooltip>
  );
};

InflationToggle.propTypes = {
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  usePresentData: PropTypes.bool.isRequired,
};

export default withStyles(styles)(InflationToggle);
